import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

Vue.config.productionTip = false;

import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserLock, faUserCheck, faLock, faLockOpen, faSpinner,faSignOutAlt,faAngleDoubleDown, faLink } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon,FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome'

library.add(faUserLock, faUserCheck,faLockOpen, faLock, faSpinner, faSignOutAlt, faAngleDoubleDown, faLink)

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('font-awesome-layers', FontAwesomeLayers);
Vue.component('font-awesome-layers-text', FontAwesomeLayersText);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
